module.exports = __webpack_public_path__ + "static/image4-5e45f9fc887e2322c221488652851545.jpg";